export default {
  problemsInDepartment(state) {
    return departmentId => state.problems.filter(el => el.departmentId === departmentId);
  }
};
